import { PaymentReminderStatus, PaymentReminderType, Purchase } from "types";

export const getPaymentReminder = (purchase: Purchase, reminders: PaymentReminderType[]) => {
    return purchase.paymentReminders?.find((value) => {
        return reminders.includes(value.type) && value.status !== PaymentReminderStatus.IGNORE;
    });
};
